<ng-container *transloco="let t; read: 'bc'">
  <div class="row">

    @for (item of links; track item; let first = $first, last = $last) {
      <div>
        @if(last) {
          <span>{{ t(item.label) }}</span>
        }@else {
          <a [routerLink]="item.route">{{ t(item.label) }}</a>
          <span>&nbsp;&gt;&nbsp;</span>
        }
      </div>
    }

  </div>
</ng-container>
